import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
//@ts-ignore
import VueCodeMirror from 'vue-codemirror-lite'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.use(VueCodeMirror)

new Vue({
  router,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
